/**
 * Under a payment-plan batch's BUF amount (US 4378/4396): says the prefilled amount is
 * this month's payment, not the plan balance, so an agent doesn't pay the plan off by
 * accident. Renders nothing for ordinary batches (amountDue null).
 */
import { formatCurrencyWithSymbol } from '../utils/formatters';

const PlanDueHint = ({ amountDue, balance }) => {
  if (amountDue == null) return null;
  return (
    <p className="mt-1 text-[11px] leading-tight text-teal-700 dark:text-teal-300 text-right">
      Due now: {formatCurrencyWithSymbol(amountDue)}
      <span className="block text-gray-500 dark:text-gray-400">
        Plan balance {formatCurrencyWithSymbol(balance)}
      </span>
    </p>
  );
};

export default PlanDueHint;
